import AgreementItem from './agreement-item';
import { AggrementContentTypes } from './types';

const AgreementContent = ({
  agreementGroup,
  type,
  customerId,
  downloadInProgress,
  downloadIsFetching,
  getAgreementFileAction,
  downloadedFileId,
}: AggrementContentTypes) => (
  <AgreementItem
    item={agreementGroup[0]}
    earlyVersions={agreementGroup.slice(1)}
    type={type}
    customerId={customerId}
    downloadInProgress={downloadInProgress}
    downloadIsFetching={downloadIsFetching}
    getAgreementFileAction={getAgreementFileAction}
    downloadedFileId={downloadedFileId}
  />
);

export default AgreementContent;
